import React from "react";
import { Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { Chip } from "../chip/Chips.js";
import { ChipVariant, ChipType } from "../chip/types.js";
import { LocalizedText } from "../i18n/LocalizedText.js";
import { Icon, IconColor } from "../icons/Icon.js";
import { CustomIcon } from "../icons/types.js";
import "../icons/ExpandMoreIcon.js";
import "../../localization/MessageLocalizer.js";
import "../../localization/LocaleProvider.js";
import { sharedLocalization } from "../../localization/sharedResources.js";
const useClasses = makeStyles()((theme) => ({
  multiStepFilterHeaderCloseContainer: {
    display: "flex",
    minWidth: "50px",
    marginLeft: "auto",
    alignItems: "center"
  },
  multiStepFilterHeaderCloseChip: {
    marginLeft: "auto",
    display: "flex",
    alignItems: "center"
  },
  multiStepFilterHeaderCloseIcon: {
    fontSize: theme.typography.caption.fontSize
  },
  multiStepFilterHeader: {
    display: "flex",
    margin: theme.spacing(1.5)
  },
  multiStepFilterHeaderBackContainer: {
    display: "flex",
    minWidth: "50px",
    marginRight: "auto",
    alignItems: "center"
  },
  multiStepFilterHeaderLabel: {
    alignItems: "center"
  },
  multiStepFilterHeaderBackButton: {
    cursor: "pointer",
    color: theme.palette.text.secondary,
    display: "flex",
    marginRight: "auto",
    minWidth: "50px",
    alignItems: "center"
  },
  multiStepFilterHeaderIcon: {
    fontSize: theme.typography.caption.fontSize,
    marginRight: theme.spacing(1)
  }
}));
function MultiStepFilterHeader({ onBack, label, onClose }) {
  const { classes } = useClasses();
  return /* @__PURE__ */ React.createElement("div", { className: classes.multiStepFilterHeader }, /* @__PURE__ */ React.createElement("div", { className: classes.multiStepFilterHeaderBackContainer }, onBack ? /* @__PURE__ */ React.createElement(Typography, { variant: "body1", className: classes.multiStepFilterHeaderBackButton, onClick: onBack }, /* @__PURE__ */ React.createElement(Icon, { icon: CustomIcon.LessThan, className: classes.multiStepFilterHeaderIcon }), /* @__PURE__ */ React.createElement(LocalizedText, { label: sharedLocalization.backButtonLabel })) : null), /* @__PURE__ */ React.createElement(Typography, { variant: "h6", className: classes.multiStepFilterHeaderLabel }, /* @__PURE__ */ React.createElement(LocalizedText, { label })), /* @__PURE__ */ React.createElement(Typography, { variant: "body1", className: classes.multiStepFilterHeaderCloseContainer }, /* @__PURE__ */ React.createElement(
    Chip,
    {
      fillWidth: false,
      chipType: ChipType.Mark,
      chipVariant: ChipVariant.Grey,
      onClick: onClose,
      className: classes.multiStepFilterHeaderCloseChip,
      label: /* @__PURE__ */ React.createElement(
        Icon,
        {
          icon: CustomIcon.CancelOutline,
          className: classes.multiStepFilterHeaderCloseIcon,
          color: IconColor.Secondary
        }
      )
    }
  )));
}
export {
  MultiStepFilterHeader
};
//# sourceMappingURL=MultiStepFilterHeader.js.map
